export const RedirectUrlAfterLogin = () => {
    const currentUrl = window.location.pathname;
  
    localStorage.setItem("redirectUrl", currentUrl);
  return (
  <>
  </>
  )
}
